import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
//Styles
import { ContainerFooterStyled } from '../container-wave.component.styled';
//Components
import { ButtonComponent } from '../../button/button.component';
const ContainerWaveFooterComponent = ({ footer, styles }) => (footer ? (_jsxs(ContainerFooterStyled, { styles: styles, children: [footer?.firstButton && _jsx(ButtonComponent, { ...footer?.firstButton }), footer?.secondButton && _jsx(ButtonComponent, { ...footer?.secondButton })] })) : null);
export { ContainerWaveFooterComponent };
//# sourceMappingURL=container-wave-footer.component.js.map